module.exports = __webpack_public_path__ + "assets/img/menu-news-white.79b1b471.svg";